export default {
  'result.fail.error.authorization': 'Unauthorized request, please try again or log in again!',
  'result.fail.error.authorization.failed.retry': 'Authorization has expired, trying to retry!',
  'result.fail.error.retry': 'There was an error with the request, please try again later'
}
